import { List, ListInner, TableStyled } from 'app/Pages/common/List/styles';
import Pagination from 'app/Components/common/Pagination';
import React from 'react';
import { TFetchStatus } from 'models';
import { TUser } from 'app/Pages/common';
import { TTableData } from './index';
import { useHistory } from 'react-router-dom';

interface IListProps {
  fetchStatus: TFetchStatus,
  noResultsText: string,
  userList: TTableData,
  handleListChangePage: (page: number) => void,
  handleSearchChange?: (value: string) => void,
}

const ListComponent = ({
  handleSearchChange,
  noResultsText,
  fetchStatus,
  userList,
  handleListChangePage
} : IListProps) => {
  const history = useHistory();

  return (
    <List step="list" noPadding={true}>
      <ListInner>
        <TableStyled
          dataStatus={fetchStatus as string}
          data={userList.results ? userList.results as never[] : undefined}
          noResultsText={noResultsText || 'No results'}
          onClickRow={(index, data: TUser) => history.push(`/user/profile/${data.id}/summary`)}
          // selectedId={selectedUser ? selectedUser.id : undefined}
          handleSearchChange={handleSearchChange}
          columns={[
            {
              name: 'name',
              onRender: renderNameCol,
              styles: {
                flex: 1
              }
            },
            {
              name: 'email',
              onRender: renderEmailCol,
              styles: {
                flex: 1
              }
            },
            {
              name: 'role',
              onRender: (row) => renderRoleCol(row),
              styles: {
                flex: 1
              }
            }
          ]}
        />
        {userList?.last_page && userList.last_page > 1 ? Pagination({ page: userList.page as number, last_page: userList.last_page }, handleListChangePage) : null}
      </ListInner>
    </List>
  );
};

const renderNameCol = (row: TUser) => <>{row.props.name}</>;

const renderEmailCol = (row: TUser) => <>{row.props.email}</>;

const renderRoleCol = (row: TUser) => <>
  {row.role?.name} in {row.role?.group?.title || row.role?.group?.name} ({row.role?.group?.domain_tag})
</>;

export default ListComponent;
